import { Drawer, Skeleton } from 'antd'
import React, { Suspense } from 'react'

import { drawerAndModalWidth } from '../../../util/guideline'
import { CreateManagedFund } from './CreateManagedFund'

interface CreateManagedFundDrawerProps {
  domain: string
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const CreateManagedFundDrawer = ({ domain, isVisible, onSuccess, onClose }: CreateManagedFundDrawerProps) => (
  <Drawer
    title="Create Managed Fund"
    placement="right"
    onClose={onClose}
    open={isVisible}
    width={drawerAndModalWidth}
    destroyOnClose
  >
    <Suspense fallback={<Skeleton />}>
      <CreateManagedFund domain={domain} onSuccess={onSuccess} />
    </Suspense>
  </Drawer>
)
